export default {

  about: {
    // 关于我们
    aboutUs: 'About us',
    des1: "Mints For China's first digital play platform, based on blockchain technology to confirm the rights of digital content, to provide trusted storage technology, collection digital vouchers technology services. Redefine new ways of collecting through smartphones and electronic screens, which are everywhere in our lives. We are committed to continuously improving the interactive experience of consumption and collection of digital collections.",
    des2: 'Telephone:',
    des3: 'Email:'
  },
  activationcode: {
    //兑换码页面
    title: 'Conversion code',
    describe: 'Please enter the 16 - digit exchange code to exchange',
    placeholder: 'Please enter the exchange code',
    activationBtn: 'Immediately change',
    service: 'Consulting service',
    ruleTitle: 'Exchange code rules',
    rule1: '1. Please complete the real-name authentication first. Only users over 18 years old are supported.',
    rule1: '2. After entering the correct exchange code, you can obtain the corresponding digital collection.',
    rule1: '3. One exchange code can only be exchanged once and cannot be used repeatedly.',
    status_text: 'Congratulations on your successful exchange!',
    look_certificate: 'Check the certificate',
    purchaseInstructionsP1: 'Digital Certificate Description',
    purchaseInstructionsP2: 'Please read carefully and fully understand the following content',
    p4Des1: 'Based on the digital certificate for anti-counterfeiting traceability of goods, to protect the value of genuine.',
    p4Des2: 'Digital certificates have no transaction value and are only a tool for confirming rights. Speculation is not allowed.',
    p4Des3: 'This digital certificate shall not be used for speculation, over-the-counter transactions or any commercial purposes. We have the right to take necessary restrictive measures, including but not limited to freezing the account, if we find abnormal behaviors such as speculation, suspected illegal behaviors or behaviors prohibited by this agreement.',
    p4Des4: 'Please stay away from irrational speculation and guard against fraud risks.',
    p4Des5: 'Based on the digital certificate for anti-counterfeiting traceability of goods, to protect the value of genuine.',
    p4Des6: 'Digital certificates have no transaction value and are only a tool for confirming rights. Speculation is not allowed.',
    p4Des7: 'This digital certificate can be transferred, and the transfer procedure shall be adjusted from time to time in accordance with national laws, regulations and policies.',
    p4Des8: 'This digital certificate shall not be used for speculation, over-the-counter transactions or any commercial purposes. We have the right to take necessary restrictive measures, including but not limited to freezing the account, if we find abnormal behaviors such as speculation, suspected illegal behaviors or behaviors prohibited by this agreement.',
    p4Des9: 'Please stay away from irrational speculation and guard against fraud risks.',
    p4Des10: 'Based on the digital certificate for anti-counterfeiting traceability of goods, to protect the value of genuine.',
    p4Des11: 'Digital certificates have no transaction value and are only a tool for confirming rights. Speculation is not allowed.',
    p4Des12: 'To prevent hype, this digital certificate must be held at least up to',
    p4Des122: 'The transfer procedure shall be adjusted irregularly according to national laws, regulations and policies.',
    p4Des13: 'This digital certificate shall not be used for speculation, over-the-counter transactions or any commercial purposes. We have the right to take necessary restrictive measures, including but not limited to freezing the account, if we find abnormal behaviors such as speculation, suspected illegal behaviors or behaviors prohibited by this agreement.',
    p4Des14: 'Please stay away from irrational speculation and guard against fraud risks.',
    refuseBtn: 'cancel',
    agreeBtn: 'exchange',
    agreeBtn1: 'exchange',
  },
  bankAgreement: {
    //兑协议页面
  },
  blindbox: {
    //快速了解数字资产页面
  },

  infiniteBoxDetail: {
    buy: 'buy',
    moreBuy: 'most',
    count: 'count',
    selectCount: 'Select the number of',
    youzan: {
      text: "Whether the order with likes is successful",
      btn: "close",
      btn2: "Go check",
    }
  },
  public: {
    money: '$',
    endLine: 'end',
    qx: 'cancel',
    qr: 'confirm',
    qd: 'confirm',
    recommendenTitle: 'You May Get ',
  },

  //盲盒详情
  boxDetail: {
    joinRoomSucc: "Successfully joined the waiting room!",
    uMost: 'You can be up to ',
    timeOut: 'Time out, please queue up again',
    waive: 'waive',
    continue: 'continue',
    isWaive: 'Give up or not',
    isWaive2: '？You have to get back in line after giving up.',
    now: '',
    selectCount: 'Select the number of',
    moreBuy: 'most',
    count: 'count',
    a: '',
    //盲盒详情页面
    yy: 'Existing',
    rcyhd: 'Participate in activities',
    lj: 'immediately',
    lq: 'receive ',
    gm: 'buy ',
    qmhy: "There's more ahead",
    rzzpdgm: 'People are lining up to buy',
    y: 'stop',
    lw: 'Finish receiving',
    sq: 'sell out',
    kq: 'open',
    qs: 'sale',
    isshowlastcount: 'Surplus',
    isshowtotalcount: 'Total ',
    money: '$',
    waitingRoomCount: 'There are  users in the activity. ',
    showQueueModel: "View the queue details ",
    timeInterval2: 'Before the waiting room opens',
    timeInterval: "Before the activity begins",
    sort: "person in front waiting for purchase.  ",
    joinWaitingRoom: "Join in the Waiting Room",
    NumberFenpei: 'Number Assigning',
    realTimeTitle: 'Activity Time ',
    beijingStartwaittime: 'Opening Hour：',
    beijingStartTime: "Blind box on sale",
    beijingStartTime1: 'Blind box collection',
    realTimeTitle2: 'Blind box details',
    detailTipsTitle: "Digital Collections Tips ",
    tipsCon: "Supported by the blockchain technology, any digital commodity can do the right including paintings, videos, models or tickets, that is, owning its own “digital ID card”which will be stored on the blockchain permanently and provides unique values.",
    tipsCon1: 'Mints’ digital collections all own their unique identification on the Conflux based on the technical protocol of blockchain which cannot be changed and separated. Conflux provided technical supports of the underlying blockchain technology for the collection of digital art, offering the platform technologies of trusted testimony and digital commodity affirmation. ',
    tipsCon1Text: 'Attentions',
    tipsCon1Text2: 'Pleae complete the real name authentication before purchase.',
    tipsCon1Text3: '*No return or refund once the digital commodities are sold because of their particularities. ',
    recommendenTitle: 'You May Get ',
    modal: "You have placed an order and haven't paid yet. Please go to pay",
    modalOkText: 'cancel',
    modalCancelText: 'Sure',
    notStardTitleIsFree1: 'Activity has started. You have joined the queue',
    notStardTitleIsFree0: 'The campaign has begun. You have joined the queue',
    rzzpd: 'People are lining up',
    BuyersText: 'nickname',
    priceText: 'The queue,',
    codeText: 'state',
    hy: 'There are',
    wyhzpdz: 'There are two users in the queue',
    pendingInfo1: '*Note: when other users receive the blind box, there is',
    pendingInfo2: '2 minutes',
    pendingInfo3: 'Claim time, during this period, your queue rank will not change, when other users claim the queue rank will be refreshed.',
    pendingInfo4: '*Note: When other users make purchases, there are',
    pendingInfo5: 'Order time, during this period, your queue rank will not change, when other users purchase the queue rank will be refreshed.',
    Leave1: 'Leave the queue',
    Leave2: 'After leaving you will lose',
    Leave3: 'The opportunity to',
    qr: 'confirm',
    qx: 'cancel',
    waitingTipsPo1: 'Please join the waiting room in advance before the event begins.',
    waitingTipsPo2: 'At the beginning of the event, we will give priority to all online users who are already in the waiting room and randomly assign numbers to them',
    waitingTipsPo3: 'If you join the waiting room after the event starts, you will follow the existing maximum queue number +1。',
    purchaseInstructions1: 'instructions',
    purchaseInstructions2: 'Please read carefully and fully understand the following content',
    purchaseInstructions3: 'Digital collections are virtual digital goods, not physical objects, only for real-name authenticated users over 18 years old',
    purchaseInstructions4: 'Once the goods are sold',
    purchaseInstructions5: ', do not support return or exchange.',
    purchaseInstructions6: 'The copyright of the digital collection is owned by the publisher or the creator, and users are not allowed to use the digital collection for any commercial purposes except with the written consent of the copyright owner.',
    purchaseInstructions7: 'Digital collectibles do not currently support trading.',
    purchaseInstructions8: 'This digital collection shall not be used for speculation, over-the-counter trading or any commercial purposes. We have the right to take necessary restrictive measures if we find any abnormal behavior such as hype, suspected violation of laws and regulations or behaviors prohibited by this agreement. Including but not limited to freezing accounts.',
    purchaseInstructions9: 'Please stay away from irrational speculation of digital collections to prevent fraud risks.',
    jj: 'Refuse',
    ty: 'agree',
    xhtcp1: 'Destroy that',
    xhtcp2: 'The digital collection that is not sold within 2 months will be destroyed automatically. To ensure that the sale of digital collections are recognized by users.',
    xhtcp3: 'Know the',
    leaveModalContent: "After leaving, you will lose the opportunity to purchase. Are you sure to leave the queue?",
    leaveModalContent2: "After leaving, you will lose the opportunity to pick up the goods. Are you sure to leave the queue?",
    slbnwk: "Quantity cannot be empty",
    mhyxj: "The blind box has been removed from the shelves",
    pendingListStatus: {
      1: "In the queue",
      2: "In the purchase",
      3: "In the payment",
    },
    pendingListStatus2: {
      1: "In the queue",
      2: "To receive the",
      3: "To receive the",
    },
  },
  boxList: {
    //盲盒列表页面
    status4FalseType1: 'On Sale',
    status4FalseType2: 'have in hand',
    status4FalseType3: 'Receiving',
    status4TrueType1: 'Sold Out',
    status4TrueType2: 'Has ended',
    status4TrueType3: "Collected",
    loadText: 'No relevant data found',
    loadText2: 'No more data',
    newBox: 'The new box.',
    all: 'All',
    ing: 'On Sale',
    end: 'Sold Out',
  },
  certificateFreeBox: {
    //特殊盲盒页面
    surplus: 'a',
    isshowlastcount: 'The remaining',
    isshowtotalcount: 'The total number of',
    limitbuycount: 'Number of available blind boxes:',
    getBox: 'Get the blind box',
    timeInterval: 'From the start of activity',
    ylw: 'Brought up',
    hdsj: 'The activity time',
    dhskf: 'Waiting room open:',
    kq: 'open',
    mhlq: 'Blind box collection:',
    lq: 'To receive',
    kf: 'open',
    mhxq: 'Blind box details',
    szscpxts: 'Tips for Digital Collectibles',
    tipsCon: 'With the support of block chain technology, painting, video, model, tickets and other digital products can be made of any kind, which has a of their own, "digital id", this unique data content will be permanently stored in the block chain, carry digital goods can be owned and its unique value.',
    tipsCon1: "Thin box digital collectibles are digital goods based on the 'tree blockchain' technology protocol. Each digital collectible has a unique identity on the 'tree blockchain', permanent storage and the same immutable, indivisible characteristics. 'Tree map blockchain' provides the bottom technology support of blockchain for the collection of digital collections, and provides the trusted storage extension and digital commodity rights confirmation technology for the platform.",
    tipsCon1Text: 'Matters needing attention',
    tipsCon1Text2: '*Please complete the real-name authentication before purchasing',
    tipsCon1Text3: '*Because of the particularity of digital products, can not be tampered with, once sales do not support the return',
    recommendenTitle: 'You may get',
    lqxzp1: 'To receive instructions',
    lqxzp2: 'Please read carefully and fully understand the following content',
    lqxzp3: 'Digital collections are virtual digital goods, not physical objects, only for real-name authenticated users over 18 years old To receive。',
    lqxzp4: 'Once the goods are sold To receive, do not support return or exchange.',
    lqxzp5: 'The copyright of the digital collection is owned by the publisher or the creator, and users are not allowed to use the digital collection for any commercial purposes except with the written consent of the copyright owner.',
    lqxzp6: 'Digital collectibles do not currently support trading.',
    lqxzp7: 'This digital collection shall not be used for speculation, over-the-counter trading or any commercial purposes. We have the right to take necessary restrictive measures if we find any abnormal behavior such as hype, suspected violation of laws and regulations or behaviors prohibited by this agreement. Including but not limited to freezing accounts.',
    lqxzp8: 'Please stay away from irrational speculation of digital collections to prevent fraud risks.',
    refuseBtn: 'Refuse',
    agreeBtn1: 'agree',
    xhtcp1: 'Destroy that',
    xhtcp2: 'The digital collection that is not sold within 2 months will be destroyed automatically. To ensure that the sale of digital collections are recognized by users.',
    xhtcp3: 'Know the',
    nzdklq: 'You can take it at most',
    fen: 'Copy of the',
    slbnwk: 'Quantity cannot be empty',
    nzwlqzg: 'You are temporarily ineligible',

  },
  //了解薄荷
  blindbox: {
    Noviceguide: "Newbie Guide",
    commonProblem: "Common Questions",
    blindboxDes1: "What is Mints?",
    blindboxDes2: "Thin box mints is the first digital tide play platform in China. It confirms the right of digital content based on blockchain technology and provides trusted storage technology and collection digital certificate technology services. Redefine new collection methods through smart phones and electronic screens that can be seen everywhere in life. Committed to continuously improving the interactive experience of consumption and collection of digital collections.",
    blindboxDes3: "What are digital collections?",
    blindboxDes4: "At some point, many objects become bad by passing their expiration date with time and space, such as CDs and DVDs, so do the sneakers limited edition and even so do those priceless paintings. It seems that there is nothing existing forever in the world while the appearance of digital collection helps turn the situation at once.",
    blindboxDes5: 'Digital collections can cover everything from videos, images, models to games, tickets and star cards. Once any digital commodity is on the chain, You have a unique ID card "digital certificate" that is always in the chain. Every artwork belongs to you only. It is tamperable, indivisible, unrepeatable and unique! Just like snowflakes, every piece is unique. This is digital collections.',
    blindboxDes6: "How do the digital collections become so popular?",
    blindboxDes7: "Digital collections have become a new evolutionary trend of art works, networks have become a new tool of digital collection while virtual space a new carrier of digital collection. Mobile phones and computers even build new display scenarios for digital collections.In this way, digital collection will certainly change the traditional art market and break the traditional aesthetic paradigm, making the forms of art more varied. ",
    blindboxDes8: 'Here, every netizen can establish his new identity as a "collector of digital collections" and easily configure the collections under his name. Digital works of art broaden the possibility of a new generation of "art collectors". The way of online preservation makes the collection lose the constraints of space and time and reduce the risk of investing too much money. Through technological innovation and the rise of the community, collectors of each category can configure the attributes of the collection according to their own taste. Even a small number of art can counter attack successfully.',
    blindboxDes9: "How to play with digital collecions?",
    blindboxDes10: 'From the digital art adventure game created by Louis Vuitton for the brand to every classic moment restored in the digital "star card" carrying memory and future in NBA top shot. From the digital blessing card launched by Dunhuang research institute together with users of the whole network in the Spring Festival this year to "light up the Mogao Grottoes", to the 2020 Netease future conference, it has also been used as a ticket. Now, digital collections have penetrated into public welfare, games, trendy play, tourism, ticketing and other fields, and become the trend of the future.',
    blindboxDes11: 'With digital collections, the collection itself has broken through the limitation of space. In the future, with the application of AR / VR and other sub era technologies, every digital art collector can have his own unique collection Museum. In this collection museum that only belongs to you, you can enjoy the pleasure of appreciation and collection, and invite friends to come to the museum to share your collection.',
    blindboxDes12: "Why is Mints worth your trust?",
    blindboxDes13: 'On Mints, digital collections are the goods issued based on the technical protocol of “Blockchain”, supported with the underlying technology, the trusted testimony technology and the digital commodity voucher technology. On the platform, you will enjoy freer choices of art no matter you are creaters or collectors in a more colorful and cooler way. ',
    blindboxDes14: 'We welcome you,',
    blindboxDes15: 'Welcome to the thin box, and more welcome to the future,',
    blindboxDes16: 'Become a unique digital collection collector here.',
    blindboxDes17: 'What are digital collections?',
    blindboxDes18: 'Digital collections, no matter they are videos, pictures, models or games, tickets, or star cards, will own their sole and permanent ID card“digital certificate”once they are uplinked. They exist only for you which cannot be changed, separated or duplicated, unique just like snowflakes.',
    blindboxDes19: 'How to obtain digital collections?',
    blindboxDes20: 'On Mints, you can obtain digital collections in different approaches, for example, purchasing blind boxes, taking part in activities, etc. At present, all the digital collections can only purchased by the Chinese with RMB. ',
    blindboxDes21: 'Why is blindbox selected?',
    blindboxDes22: 'Compared with the direct purchase of digital collections, the form of blind box makes the collection process full of surprises and fun. Through the way of blind box, collectors can find more high-quality digital collections that may never be noticed. It is also possible to obtain digital collections that are more valuable than the blind box itself.',
    blindboxDes23: 'Blind boxes are sold on the official platform, which are divided into two categories: sending blind boxes and Artist Series blind boxes',
    blindboxDes24: 'The basic blind box is divided into three levels: classic, rare and legendary. Different levels of blind boxes drop a digital collection of corresponding levels. At the same time, low-level blind boxes may also open high-level digital collections.',
    blindboxDes25: "Artist Series blind box, generally only one digital collection in the artist's works is dropped,",
    blindboxDes26: 'How to purchase a blind box?',
    blindboxDes27: "Enter  Blindbox Details through the“home page”or the navigation page of“blindbox”; ",
    blindboxDes28: ' After the waiting room opens, click on “Join In”, and then the system will automatically and randomly assign users a queue number to purchase when blind boxes become on sale; ',
    blindboxDes29: 'After entering the purchase page and completing payment, users can obtain digital collections directly by opening the blind box or make a collection and later open the blind box on “My Center”; ',
    blindboxDes30: 'After opening the blind box purchased, you can see the digital collection obtained at any time on “My Center”. ',
    blindboxDes31: 'At present, blind boxes can only be purchased by the Chinese with WeChat or Alipay, and refunds are unvailable as the transactions have been recorded on the blockchain.  ',
    blindboxDes32: 'How to manage your "My Center"?',
    blindboxDes33: 'Under the "collected" tab is the works you have obtained; Under the "blind box" tab, the blind box that you have not opened after purchasing the blind box.',
    blindboxDes34: 'You can modify your MNS, avatar and other information in "my - personal home page".',
    blindboxDes35: 'What are credits?',
    blindboxDes36: 'You will obtain credits by purchasing blind boxes or taking part in activities. With credits, you may unlock the later purchase of special blind boxes, and you will enjoy more games on the platform in the future. To learn more about credit obtaining rules, it is available to replay with “credit obtaining”in the service number of Mints. ',
    blindboxDes37: 'How to send a digital collection',
    blindboxDes38: 'Some digital collections can be presented, which will be shown in Blindbox Details when you purchase them. Please pay attention to it; ',
    blindboxDes39: 'If a digital collection can be presented, the one who is given can obtain it after registering only if you select “Presentation”and fill in his phone number and personal information. '
  },
  creatorDetail: {
    //创作家详情页面
    loadText: 'No relevant data were found',
    loadText2: 'No more data available',
  },
  creatorList: {
    //创作家列表页面
    loadText: 'No relevant data were found',
    loadText2: 'No more data available',
  },
  freeSuccess: {
    //领取盲盒成功页面
    successDesc: 'Get the success',
    lookDetail: 'To view',
    contentText: 'Jump to the blind box opening page after seconds'
  },

  getBoxSuper: {
    //超能一家人打开盲盒页面
    laterOpen: 'Go to personal Center',
    Dropnum1: 'Blind box drops',
    Dropnum2: 'A work',
    laterOpen2: 'Open later',
    openBoxBtn: 'Open the blind box',
    imgLabelimg: 'Save the picture'
  },
  getGift: {
    //领取作品页面
    goShow3DPage: 'The 3 d space',
    giveMessageInfo1: 'Giving people',
    leaveMessageDiv: 'A message from a friend',
    nowReceive: 'Immediately to receive',
    isFiled: 'Get the failure',
    okText: 'Shut down',
    cancelText: 'Back to the home page',
  },
  giftLogin: {
    //领取作品登录页面
    loginText: 'Please enter your phone number',
    loginText2: 'Log in or register your thin box account',
    placeholder1: 'Please enter your phone number',
    getCode: 'Obtaining verification code',
    yzm: 'Verification code',
    placeholder2: 'Enter a six-digit SMS verification code',
    login: 'login',
    changeCheck: 'The unregistered mobile phone will automatically log in after passing the verification, and the registration means consent',
    agreement: '《Thin Box User Agreement》',
    and: 'and',
    conceal: '《Privacy Policy》',
    noCheckText: 'Please read and check page protocol',
    isSHowBtn: 'I have read and agree',
    sendMessage: 'Send a success',
    telText: 'Please fill in your mobile phone number',
    yzmText: 'Please fill in the verification code',
  },
  giveGift: {
    //赠送作品页面
    phoneText: 'Get a hand phone number',
    MNSPlaceholder: "Please enter the recipient's MNS/Address",
    telPlaceholder: "Please enter the recipient's mobile phone number",
    leaveMessageDiv: 'Leave a message',
    msgPlaceholder: 'Please enter your message to the recipient (optional)',
    reminderTips1: 'Tips:',
    reminderTips2: "1. Please check the recipient's mobile phone number carefully, if you fill in the wrong information, the recipient will not be able to receive it.",
    reminderTips22: "2. If you need to modify the donee's information, you can fill in and submit it again, and the donee before the modification can not claim the collection.",
    reminderTips23: "2. If you need to modify the donee's information, you can fill in and submit it again, and the donee before the modification can not claim the collection.",
    confirmBrn: 'cancel',
    sureGive: 'giving',
    okText: "no",
    cancelText: "yes",
    isRegister1: "The user is not registered on the platform! Please inform friends to use",
    isRegister2: "Mobile phone number for collection",
    copySuccess: 'Copy success',
    navName1: "MNS/Address",
    navName2: "Mobile number",
    text1: "(optional)",
    text2: "2. This digital collection can be given away after it is given.",
    text3: "Confirm the gift",
    text4: "Enter the operation password",
    text5: "Forgot your password? Use",
    text6: "SMS Verification",
    text7: "The phone number has not been registered in the box. If you confirm the gift, we will notify the other party to receive it via SMS",
    text8: "Whether the digital collection is confirmed to be given to the user",
    text9: "Please enter the correct phone number format",
    text10: "Please enter MNS/address",
    text11: "Please enter your phone number",
  },
  giveSuccess: {
    //赠送作品成功页面
    successText: 'Presented a successful',
    timeText: 'Jump to work details page after seconds'
  },
  //首页
  index: {
    giftsCon: 'Received from',
    toMY: 'Click to view',
    Newboxrec: "New box",
    lookMore: 'more',
    digital: "digital certificate",
    creator: 'Creator',
    internet: {
      title: "Warm reminder",
      text1: "1. Digital collections are virtual digital goods, not real objects, and can only be purchased by users who have been authenticated by their real names and are over 18 years old.",
      text2: "2. For sale, return and exchange is not supported.",
      text3: "3. Digital collections do not currently support transactions.",
      text4: "4. Digital collections cannot be used for speculation or over-the-counter transactions. For behaviors prohibited by the agreement, we have the right to take necessary restrictive measures; including but not limited to freezing accounts, etc.",
      text5: "5. Reasonably evaluate the ability to identify risks and take risks, participate rationally in digital collections, and stay away from irrational digital collections. Hype to prevent fraud risks.",
      btn: "I got it",
    },
    jayModel: {
      title: "#Jay Lun Yuan Universe Concert#",
      title2: "Tips",
      num: "people",
      text: "If you want to see the Metaverse concert held by the thin box and Jaylen, please enter the music space to 'like'. When the likes reach 18:00, we will open a new door.",
      text2: "Please download the APP and go to the music space to like and experience",
      btn: "Go to like",
      btn2: "go to download",
    }
  },
  login: {
    //登录页面
    title: 'Login/Register',
    tel: 'Phone Number',
    telPlaceholder: 'Please enter your phone number',
    getCode: 'send',
    yzmtitle: 'Verification Code',
    yzmPlaceholder: 'Please enter 6 digits of vertification code. ',
    getCode: 'send',
    login: 'login',
    changeCheck: 'The unregistered mobile phone will automatically log in after passing the verification, and the registration means consent',
    agreement: '《Thin Box User Agreement》',
    and: 'and',
    conceal: '《Privacy policy》',
    noCheckText: 'Please read and check page protocol',
    isSHowBtn: 'I have read and agree',
    sendSuccess: 'Send a success',
    placeTel: 'Please enter your phone number',
    placeYzm: 'Please enter 6 digits of vertification code. '
  },
  lotterCode: {
    //抽签码盲盒页面
  },
  openBox: {
    //打开盲盒后作品展示页面
    showText: 'View the entire collection'
  },
  openBoxSuper: {
    //超能一家人打开盲盒后作品展示页面
    laterOpen1: 'Go to personal Center',
    downloadBase64Img: 'Save the picture',
    downloadBase64Text: 'Long press to save the picture',
  },
  openMyBox: {
    openBoxBtn: 'Return to personal home page',
    creatorName: 'Creator',
    tags: 'type',
    opusopusseriesName: 'A series of',
    timer: 'timer',
    adownload: 'Wechat does not support download, please click on the upper right corner to use another browser to open!',

  },
  page3D: {
    //3d展示页面
  },
  payment: {
    //支付页面
    dropNum1: 'Blind boxes can drop at most',
    dropNum2: 'A collection of',
    customerInfo1: 'Consignee',
    customerInfo2: 'Payment Amount',
    apliyCheckFn: 'Alipay Payment',
    bankCheckFn: 'Bank card Quick Payment',
    surePayBtnFn: 'Confirm Payment',
    modal: 'It is reminded that you have an order unpaid, will you continue？',
    okText: 'Continue to pay',
    cancelText: 'Cancel',
    payResultModal: 'Have you completed this payment?',
    okText2: 'Did not pay',
    cancelText2: 'I have to pay',
    payResultSuccess: 'Payment is in progress, please wait patiently!',
    payErrorText1: 'The order has timed out, please reorder',
    payErrorText2: 'Transaction failure',
  },
  paymentSuccess: {
    //支付成功页面
    successDesc: 'Pay for success',
    mnsSuccess: 'To view',
    orderInfo1: 'The order no.',
    orderInfo2: 'Name of commodity',
    orderInfo3: 'Amount of real pay',
    orderInfo4: 'Bank card discount',
    toIndex: 'Back to the home page',
    lookDetail: 'To view',
    contentText1: 'Open the blind box in seconds',
    contentText2: 'Seconds after return',
    contentText3: 'View works in seconds',
  },
  payMiddle: {
    //支付结果跳转页面
    payStatus1: 'Pay for success',
    payStatus2: 'Return to the thin box',
    payStatus21: 'Check the MNS',
    payStatus22: 'To open blind box',
    payStatus3: 'Pay for failure',
    payStatus4: 'Return the thin box to pay again',
  },
  receive: {
    //证书页面
    creatorName: 'Creator:',
    confluxaddress: 'confluxaddress:',
    confluxname: ' confluxname:',
    ownername: 'ownername:',
    nftid: 'NFTID：',
    have: 'Already owns this collection',
    lookInfo: 'details',
    noHave: "You don't own this collection yet",
    goService: 'Consulting service',
    receiveAlertTit: 'Warm prompt',
    receiveAlertText: 'No relevant digital certificate can be found under this account.',
    receiveAlertText2: 'Please try again later!',
    receiveAlertConfirm: 'confirm',
    purchaseInstructionsTit: 'Digital Certificate Description',
    purchaseInstructionsText1: 'Based on the digital certificate for anti-counterfeiting traceability of goods, to protect the value of genuine.',
    purchaseInstructionsText2: 'Digital certificates have no transaction value and are only a tool for confirming rights. Speculation is not allowed.',
    purchaseInstructionsText3: 'This digital certificate shall not be used for speculation, over-the-counter transactions or any commercial purposes. We have the right to take necessary restrictive measures, including but not limited to freezing the account, if we find abnormal behaviors such as speculation, suspected illegal behaviors or behaviors prohibited by this agreement.',
    purchaseInstructionsText4: 'This digital certificate can be transferred, and the transfer procedure shall be adjusted from time to time in accordance with national laws, regulations and policies.',
    purchaseInstructionsText5: 'Please stay away from irrational speculation and guard against fraud risks.',
    refuseBtn: 'cancel',
    agreeBtn: 'To receive',
    purchaseInstructions2Tit: 'To receive instructions',
    purchaseInstructions2Text1: 'Please read carefully and fully understand the following content',
    purchaseInstructions2Text2: 'Digital collection is virtual digital goods, not physical objects, only for real-name authentication of users over 18 years old.',
    purchaseInstructions2Text3: 'Once received, the goods cannot be returned or changed.',
    purchaseInstructions2Text4: 'The copyright of the digital collection is owned by the publisher or the creator, and users are not allowed to use the digital collection for any commercial purposes except with the written consent of the copyright owner.',
    purchaseInstructions2Text5: 'Digital collectibles do not currently support trading.',
    purchaseInstructions2Text6: 'This digital collection shall not be used for speculation, over-the-counter trading or any commercial purposes. We have the right to take necessary restrictive measures if we find any abnormal behavior such as hype, suspected violation of laws and regulations or behaviors prohibited by this agreement. Including but not limited to freezing accounts.',
    purchaseInstructions2Text7: 'Please stay away from irrational speculation of digital collections to prevent fraud risks.',

  },
  sellingTime: {
    //作品详情页面
    opusattrcustomerName: 'The owner',
    customersellerName: 'Giving people',
    saleWorkModal: 'sell',
    undercarriage: 'Take off',
    giveGift: 'giving',
    givingGift: 'giving',
    // modal
    okText: 'Continue to pay',
    cancelText: 'Cancel',
  },
  setUp: {
    //setUp页面
    xmrz: 'authentication',
    wrz: 'unauthorized',
    yrz: 'certified',
    dhm: 'Conversion code',
    yhkgl: 'Bank card management',
    jfye: 'Credits/Balance',
    operatingPass: 'Operating password'
  },
  VerificationInformation: {
    //区块链查证信息页面
  },
  wallet: {
    //钱包页面
  },
  workDetail: {
    //workDetail页面
  },
  // //添加银行卡
  addBank: {
    addBankText1: "Binding a bank card",
    addBankText: "Confirm binding bank card",
    cardNum: "Card number",
    careNumPlcae: "Bank card number",
    caredName: "Name",
    cardNamePlace: "Card opening name",
    IDName: "ID number",
    IDNamePlace: "Bank reserve ID number",
    phone: "cell-phone number",
    phonePlcae: "Bank reserved mobile phone number",
    code: "Verification Code",
    codePlcae: "SMS verification code",
    getCode: "Get verification code",
    openPay: 'Open and pay',
    agree: "accept",
    payAgreement: "《Thin box payment service agreement》",
    IncardNum: "Please enter your bank card number",
    InCardName: "Please enter the name of the card opener",
    InCardIdNum: "Please enter your bank reserve ID number",
    InCardPhone: "Please enter the bank reserved mobile phone number",
    sendSuccess: "Send a success",
    pleaseReadAggrement: "Please read and check the service agreement for unionPay users",
  },
  //银行卡列表
  bankList: {
    bankCardPay: "Bank card payment",
    payName: "Merchant name 北京擘盒科技有限公司",
    please: "please",
    complatedPay: "Internal completed payment",
    chooseBank: "Select your bank card",
    addBank: "Add a bank card",
    goPay: "To pay for",
    setPwd: "Please set your payment password first",
    confirm: "cancel",
    goSet: "To set up",
    isComplatePay: "Have you completed this payment?",
    noPay: "Did not pay",
    isPay: "I have to pay",
    payStatus: "Payment is in progress, please wait patiently!",
    bankUpper: "The number of bank cards has reached the maximum",
    orderTimeOut: "The order has timed out, please reorder",
    payError: "Transaction failure",
  },
  //银行卡管理
  bankManage: {
    bankManage: "Bank card management",
    noBank: "No bank card currently available",
    removeBind: "Remove the binding",
    isRemoveBind: "Unbind or not",
    removeTips: "After unbinding, the bank card cannot be used for payment on the platform",
    Sure: "Sure",
    confirm: "cancel",
    operationSuccess: "Operation is successful",
    bankNumUpper: "The number of bank cards has reached the upper limit"
  },
  //免费邀请盲盒
  freeBox: {
    activityStart: "Countdown",
    activityEnd: "Countdown",
    leadBoxNum: "Number of blind boxes you can receive:",
    InvitePerson: "Invite new users to register and get more blind boxes",
    goInvite: "To invite",
    nowReceive: "Immediately to receive",
    isgone: 'Brought up',
    activityTime: "The activity time",
    activityTimeDes: "Activity opening:",
    activityTimeDesSpan: "open",
    activityTimeDes1: "End of activity:",
    activityTimeDes1Span: "The end of the",
    boxDetailText: "details",
    receivingInstructions: "To receive instructions",
    receivingInstructionsDes1: "Please read carefully and fully understand the following content",
    receivingInstructionsDes2: "Digital collection is virtual digital goods, not physical objects, only for real-name authentication of users over 18 years old.",
    receivingInstructionsDes3: "Once received, the goods cannot be returned or changed.",
    receivingInstructionsDes4: " The copyright of the digital collection is owned by the publisher or the creator, and users are not allowed to use the digital collection for any commercial purposes except with the written consent of the copyright owner.",
    receivingInstructionsDes5: "Digital collectibles do not currently support trading.",
    receivingInstructionsDes6: "This digital collection shall not be used for speculation, over-the-counter trading or any commercial purposes. We have the right to take necessary restrictive measures if we find any abnormal behavior such as hype, suspected violation of laws and regulations or behaviors prohibited by this agreement. Including but not limited to freezing accounts.",
    receivingInstructionsDes7: "Please stay away from irrational speculation of digital collections to prevent fraud risks.",
    receivingInstructionsDes8: "Refuse",
    receivingInstructionsDes9: "agree",
    destoryDesTitle: "Destroy that",
    destoryDes1: "The digital collection that is not sold within 2 months will be destroyed automatically. To ensure that the sale of digital collections are recognized by users.",
    destoryDes2: "Know the",
    InviteDesCon: "Invite friends to sign up for more blind boxes",
    InviteDesCo1: "Every time you invite a friend to register, you can get an extra blind box",
    nowInvite: "Immediately invited",
    maxInvite: "You can take it at most",
    maxInvite1: "Copy of the",
    setTimeText: "天:时:分:秒",
    boxOff: "The blind box has been removed from the shelves",
  },
  //kyc认证
  kyc: {
    btnText1: 'start',
    btnText2: 'go later',
    authenticationError: "Authentication failed！",
    authenticationNum: "Remaining authentication times today:",
    frequency: "time",
    reUpload: "Upload again",
    return: "return",
    authenticationSuccess: "Identity authentication through!",
    complete: "complete",
    LV1Text: "Lv1 identity authentication",
    LV1TextText: "You can participate in the blind box activity through Lv1 identity authentication",
    LV1Text1: "Face recognition",
    LV1Des1: "Create your digital identity",
    LV1Des2: "Digital identity is based on blockchain address. According to laws and regulations, users are required to provide identity information. Please fill in true and valid information.",
    LV1Des3: "The block chain address can be automatically created after real-name authentication. Please confirm that the registered mobile phone number matches the real-name information.",
    reallyName: "Real name",
    namePlace: "Please enter your real name",
    getCode: "Obtaining verification code",
    Next: "next",
    cardType: "Document type",
    cerdNum: "I.d.",
    cerdNumPlace: "Please enter your id number",
    IKnow: "I have read and agree",
    userAgreement: "《User Agreement》",
    and: "and",
    privacyPolicy: "《Privacy Policy》",
    pleaseSure: "Please make sure to",
    myOperation: "I operate",
    operationDes1: "Please record in a bright light environment",
    operationDes2: "Blink 3 to 5 times during recording",
    operationDes3: "The recording lasts 3-5 seconds",
    operationDes4: "Start recording a video",
    operationDes5: "Please wait patiently while testing",
    operationDes6: "The length of the video and the speed of the phone's network affect the detection time",
    operationDes7: "confirm",
    operationDes8: "Please read and check page protocol",
    passedLV1: "The account has been authenticated by Lv1",
    confirm: "confirm",
    choose: "Please select a",
    cardError: "The id card information is incorrect",
    IDcard: "Id card",
    passIdCard: "Hong Kong, Macao and Taiwan Pass",
    passIdCard1: "Foreigner's permanent residence card",
    passIdCard2: "Passport of Chinese citizen residing abroad"
  },
  mns: {
    buyMns: "Buy MNS",
    curNoMns: "Currently, no MNS is available",
    whatMns: "What is the MNS",
    nowUseMns: "MNS currently in use",
    noMnsText: "The domain name is currently unavailable, go to buy it",
    noText: "Temporarily no data",
    isChangeNowUseMns: "Do you want to switch the current MNS?",
    Sure: "confirm",
    Confirm: "cancel",
    Obtained: "Have obtained",
    UnderReview: "In the review",
    PurchaseFailed: "Purchase failed",
    changeSuccess: "Switch successful!",
    mnsBuy: "MNS purchase",
    payMoney: "Amount payable:",
    apliyPay: "Alipay Payment",
    bankPay: "Bank card payment",
    surePay: "Confirm Payment",
    isContinuePay: "It is reminded that you have an order unpaid, will you continue？",
    continuePay: "Continue to pay",
    concelOrder: "Cancel",
    isComplatePay: "Have you completed this payment?",
    noPay: "Did not pay",
    hasPay: "I have to pay",
    transactionFailure: "Transaction failure",
    payWait: "Payment is in progress, please wait patiently!",
    payError: "Transaction failure",
    orderTimeOut: "The order has timed out, please reorder",
  },
  //支付
  pay: {
    consignee: "Consignee",
    payMoney: "Payment Amount",
    apliyPay: "Alipay Payment",
    weichatPay: "WeChat pay",
  },
  myCenter: {
    zdl: "I know",
    kfMail: "Email: info@mints.cn",
    kf: 'Contact Customer Service',
    followList: "Pay attention to the list",
    beConcerned: "fans",
    Concerned: "Focus",
    all: "all",
    noCareText: 'No attention yet',
    collectionsNum: "collections:",
    care: "Focus",
    hasCare: "followed",
    crossCorrelation: "Mutually close",
    Huiguan: "Back off",
    noCareText1: "No attention",
    isSureConfim: "Confirm whether to unfollow",
    yes: "yes",
    no: "no",
    closeSuccess: "Closed successfully!",
    careSuccess: "Focus on success!",
    Collection: "collection",
    Blindbox: "box",
    filter: "screen",
    noBoxText: "No related blind box is available",
    drop: "drop",
    individual: "a",
    noBoxText1: "There is no relevant collection at present",
    serialnumber: "Collection of serial number",
    label: "The label",
    putaway: "Pack up",
    open: "an",
    reset: "reset",
    sure: "determine",
    filteredForYou: "Screened for you",
    Articleresults: "The results of article",
    myMns: "My MNS",
    whatMns: "What is the MNS",
    mnsDes1: "MNS, short for Mints Name Service, is an extensible and open naming system based on tree graph blockchain, primarily serving user-readable block chain address mapping names, designed to provide users with short, easy-to-read names that can be purchased.",
    mnsDes2: "MNS is the starting point of your meta-universe, a digital identity card that belongs to everyone. It connects your achievements, contributions, interests and activities in the digital world, and once owned, it becomes tied to your blockchain address and becomes part of your digital assets.",
    mnsDes3: "1. After obtaining MNS, you can bind your own blockchain address.",
    mnsDes4: "2. Users need to complete real-name authentication before purchasing. Each user can search for the MNS they want to buy through the search bar. In this way, if no one has registered before, you can initiate the purchase and enter the audit stage after the payment is completed.",
    mnsDes5: "3. MNS can be composed of 26 English letters and 10 Arabic numerals in any order. At present, it can be purchased with at least 7 characters, and the suffix of '.mints 'will be automatically added after the combined text, such as' AB12.mints '.",
    mnsDes6: "4. All MNS purchases shall be reviewed before purchase. The name you set shall not infringe or be suspected of infringing the legitimate rights and interests of others. Observe the following rules when setting the name:",
    mnsDes7: "(1) The name, pronunciation, transliteration and translation shall not be the same as the real name, brand name, stage name or pen name of party or state leaders or other celebrities;",
    mnsDes8: "(2) The name, pronunciation, transliteration and translation shall not be the same as the name of a national institution or other institution;",
    mnsDes9: "(3) The name and its pronunciation, transliteration and translation shall not contain words of discrimination, insult or obscenity;",
    mnsDes10: "(4) The name and its pronunciation, transliteration and translation shall not infringe on the rights of well-known trademarks;",
    mnsDes11: "(5) Do not set the name of the account which is easy to generate ambiguity and cause others to misunderstand;",
    mnsDes12: "(6) Shall not endanger state security, divulge State secrets, subvert state power or undermine national unity;",
    mnsDes13: "(7) The public interest shall be harmed if the honor and interests of the state are not harmed;",
    mnsDes14: "(8) Shall not incite ethnic hatred or discrimination or undermine ethnic unity;",
    mnsDes15: "(9) Not to undermine the state's religious policies or propagate heresies and feudal superstitions;",
    mnsDes16: "(10) Shall not spread rumors, disturb social order or undermine social stability;",
    mnsDes17: "(11) Shall not spread obscenity, pornography, gambling, violence, murder, terror or instigate crime;",
    mnsDes18: "(12) Shall not insult or slander others or infringe upon the legitimate rights and interests of others;",
    mnsDes19: "(13) Shall not violate the Constitution or laws and regulations;",
    mnsDes20: "(14) It shall not contain other contents prohibited by laws and administrative regulations.",
    mnsDes21: "If the name you set is suspected of infringing the legitimate rights and interests of others or contains contents prohibited by laws, administrative regulations and other normative documents or regulatory policies, we have the right to reject the name.",
    mnsDes22: "5. After the name is approved, the user can have the right to use the MNS.",
    mnsDes23: "6. Your friends can follow you and visit your space through name search.",
    mnsDes24: "7. If the MNS you have purchased contains words that are suspected of infringing the legitimate rights and interests of others or contain the pronunciation, transliteration or translation of such words prohibited by normative documents and regulatory policies such as laws and administrative regulations, the Box has the right to take back the MNS you have purchased, and you have no right to use the MNS after taking back the MNS. We do not assume any responsibility for this, and you will be responsible for any direct or indirect losses and adverse consequences arising therefrom.",
    mnsDes25: "8. You understand and confirm that, due to the special nature that MNS cannot be tampered with, once MNS is sold, do not support return or Exchange.",
    mnsDes26: "You understand and acknowledge that Bobox has the right to adjust or update MNS related services in accordance with national laws and regulations, changes in regulatory policies or risk prevention needs. We will remind you of the update of MNS related services by notice or other means. Unless otherwise stated in the notice, the updated content will become effective as of the date of publication of the updated notice. If you do not accept the changed service content or functions, or do not agree with the updated content of the agreement, you must immediately stop using the related services. If you continue to use the relevant MNS service provided by The box, you will be deemed to have agreed to the changes made by us, and voluntarily accept the changed content of the agreement.",
    mnsDes27: "Buy MNS",
    nameCreater: "Blind box name/creator",
    nameCode: "Collection name/creator/series/No",
    confirm: "cancel",
    noFound: "No search results",
    tryAnother: "Try changing your search",
    InContent: "Please enter the search content",
    address: "address",
    Digitalcollection: "Digital collection",
    message: "message",
    Digitalspace: "Digital space",
    More: "more",
    careofficialAccount: "*Pay attention to the 'Mints' public account",
    downApp: "Download the APP for more benefits",
    copySuccess: "Copy success",
    loginSuccessLook: "You can view related content after login",
    mnsName: "MNS Name/address",
    allHistory: "All search records",
    delHistory: 'Clear search history',
    isDelHistory: "Delete all historical records that cannot be recovered",
    del: "remove",
    noSearchText: "No search data is available",
    noRegister: "unregistered",
    buy: "buy",
    goPayText: "You have placed an order, but it has not been paid yet, please go to pay",
    orderConfirmSuccess: "Order cancelled!",
    Domainoccupied: "Domain name occupied",
    confirm: "cancel",
    cover: "The cover",
    inuse: "use",
    Savereplacement: "Save the change",
    replacementSuccess: "Replacement successful!",
    careAccount: 'To get more information, please follow the WeChat service number of Mints.',
  },
  //超级一家人
  superFamily: {
    des1: "When the box office meets the requirements, the waiting room will be opened at 12 o 'clock the next day.",
    des2: "It's open for collection at 13:00",
    des3: "A total of 10,000 blind boxes, until the collection is finished",
    des4: "2021.1.30",
    des5: "Get the subject digital space blind box",
    des6: "Go to personal Center",
    savePicture: "Save the picture",
    Longpresspicture: "Long press to save the picture",
    copySuccessToFriend: "Copy it successfully, paste it to your friends!"
  },
  wxLogin: {
    loginRegister: "Login/Register",
    phone: "Mobile phone no.",
    phonePlcae: "Please enter your phone number",
    code: "Verification code",
    codePlcae: "Enter a six-digit SMS verification code",
    getCode: "Obtaining verification code",
    InvitationCode: "Invite code",
    InvitationCodePlace: "Mandatory, please enter your friend's invitation code",
    login: "login",
    loginTip: " The unregistered mobile phone will automatically log in after passing the verification, and the registration means consent",
    arrgement: "《Mints User Agreement》",
    and: "and",
    Privacypolicy: "《Privacy Policy》",
    loginTip1: "Please read and check page protocol",
    readagree: "I have read and agree",
    sendSuccess: "Send a success",
    fillPhone: "Please fill in your mobile phone number",
    fillCode: "Please fill in the verification code",
    fillInvitationCode: "Please fill in the invitation code",
    loginSuccess: "Login successful"
  },
  404: {
    noFind: "Sorry, the page you visited is lost ~",
    toIndex: "Return to the home page"
  },
  //兑换码
  activationcode: {
    activationcode: "Conversion code",
    activationcodeDes: "Please enter the 16 - digit exchange code to exchange",
    activationcodePlace: "Please enter the exchange code",
    Redeemnow: "Immediately change",
    customerservice: "Consulting service",
    rules: "Exchange code rules",
    rulesDes1: "1. Please complete the real-name authentication first. Only users over 18 years old are supported.",
    rulesDes2: "2. After entering the correct exchange code, you can obtain the corresponding digital collection.",
    rulesDes3: "3. One exchange code can only be exchanged once and cannot be used repeatedly.",
    exchangeSuccess: "Congratulations on your successful exchange!",
    ViewCertificate: "Check the certificate",
    digitalDes: "Digital Certificate Description",
    digitalDes1: "Please read carefully and fully understand the following content",
    digitalDes2: "Based on the digital certificate for anti-counterfeiting traceability of goods, to protect the value of genuine.",
    digitalDes3: "Digital certificates have no transaction value and are only a tool for confirming rights. Speculation is not allowed.",
    digitalDes4: "This digital certificate shall not be used for speculation, over-the-counter transactions or any commercial purposes. We have the right to take necessary restrictive measures, including but not limited to freezing the account, if we find abnormal behaviors such as speculation, suspected illegal behaviors or behaviors prohibited by this agreement.",
    digitalDes5: "Please stay away from irrational speculation and guard against fraud risks.",
    digitalDes6: "This digital certificate can be transferred, and the transfer procedure shall be adjusted from time to time in accordance with national laws, regulations and policies.",
    digitalDes7: " To prevent hype, this digital certificate must be held at least up to",
    digitalDes8: "The transfer procedure shall be adjusted irregularly according to national laws, regulations and policies.",
    confirm: "cancel",
    exchange: "exchange",
  },
  //组件
  //盲盒详情
  boxIntro: {
    boxDetailText: 'Blind box details',
    detailTipsTitle: 'Tips for Digital Collectibles',
    detailTipsDes1: '唯一编号',
    detailTipsDes2: '可信记录',
    detailTipsDes3: '永久存证',
    detailTipsDes4: '不可篡改',
    tipsCon: 'With the support of block chain technology, painting, video, model, tickets and other digital products can be made of any kind, which has a of their own, "digital id", this unique data content will be permanently stored in the block chain, carry digital goods can be owned and its unique value.',
    tipsCon1: "Thin box digital collectibles are digital goods based on the 'tree blockchain' technology protocol. Each digital collectible has a unique identity on the 'tree blockchain', permanent storage and the same immutable, indivisible characteristics. 'Tree map blockchain' provides the bottom technology support of blockchain for the collection of digital collections, and provides the trusted storage extension and digital commodity rights confirmation technology for the platform.",
    tipsCon1Text: 'Matters needing attention',
    tipsCon1Text2: '*Please complete the real-name authentication before purchasing',
    tipsCon1Text3: '*Because of the particularity of digital products, can not be tampered with, once sales do not support the return',
    recommendenTitle: "You may get",
    tipsText1: "Unique ID",
    tipsText2: "Trusted Records",
    tipsText3: "Permanent Certificate",
    tipsText4: "Cannot be tampered with",
  },
  //官方授权·树图区块链技术支持·限量发行「
  officialAuthorization: {
    des1: "Official authorization · Tree map blockchain technical support · Limited release",
    des2: "Brand protection",
    des3: "The official authorization",
    des4: "The digital collection is officially authorized by the brand and is exclusively distributed on Mints platform. Piracy is subject to investigation.",
    des5: "Tree map blockchain technology support",
    des6: "Thin box Mints digital collection is a digital commodity issued based on the 'Tree map blockchain' technology protocol. Each digital collection has a unique identifier on the 'tree Map blockchain', and cannot be copied, tampered with, and indivisible. 'Tree Map blockchain' provides blockchain underlying technical support for the issuance and transaction of digital collections, and provides trusted storage technology and digital collection certificate technical services for Mints digital trendy play collection platform.",
    des7: "Limited release",
    des8: "All digital collections on the platform are limited and time-limited, and each digital collection is provided with a unique certificate of ownership. At the same time, the platform will continue to upgrade the consumption and collection experience of goods."
  },
  //banner
  banner: {
    bannerText1: "Understand the thin box",
    bannerText2: "The age of digital art has arrived, and it is no longer impossible to fill the daily life with the interest of art collection and integrate it with the life of the open eye. With the rise of digital art, using the irreversible and untamper-able characteristics of block chain, thin box cooperates with top art creators in various fields to give each piece of work a unique ID code. On the thin box platform, everyone has the opportunity to own legendary digital art with official certification.",
    bannerText3: "In addition to making art collection a new fun with zero distance and no boundaries, thin boxes also create a platform for artists to communicate with each other in a new era. The rise of digital art will redefine the value of artistic creation and the sense of exclusive and limited collection. Add the thin box and you too can become a avant-garde art collector.",
    return: "return",
    activityStart: "From the event start time",
    activityEnd: "From the end of the activity",
    openTime: "Distance from waiting room opening hours",
    days: "day",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },
  //作品详情
  collectionDetails: {
    des1: "Official authorization · Tree map blockchain technical support · Limited release",
    info1: "Technical information",
    info2: "issuer",
    info3: "ID",
    info4: "address",
    info5: "Block chain",
    info6: "Tree graph blockchain",
    info7: "Details",
    info8: "Version num",
    info9: "collection",
    info10: "Stay on the",
    info11: "destroyed",
    classfiy: "classification",
    series: "A series of",
    slice: "fragment",
    level: "level",
    publishTime: "The album released",
    creator: "Creator",
    creatorBirthday: "Creator Birthday",
    creatorConstalltion: "Creator constellation",
    purchaseInstructionsP1: "Brand protection",
    purchaseInstructionsP2: "The official authorization",
    purchaseInstructionsP3: "The digital collection is officially authorized by the brand and is exclusively distributed on Mints platform. Piracy is subject to investigation.",
    purchaseInstructionsP4: "Tree map blockchain technology support",
    purchaseInstructionsP5: "Thin box Mints digital collection is a digital commodity issued based on the 'Tree map blockchain' technology protocol. Each digital collection has a unique identifier on the 'tree Map blockchain', and cannot be copied, tampered with, and indivisible. 'Tree Map blockchain' provides blockchain underlying technical support for the issuance and transaction of digital collections, and provides trusted storage technology and digital collection certificate technical services for Mints digital trendy play collection platform.",
    purchaseInstructionsP6: "Limited release",
    purchaseInstructionsP7: "All digital collections on the platform are limited and time-limited, and each digital collection is provided with a unique certificate of ownership. At the same time, the platform will continue to upgrade the consumption and collection experience of goods.",
    copySuccess: "Copy successful!"
  },
  //历史交易记录
  history: {
    history: "The historical record",
    buyer: "buyers",
    price: "The price",
    code: "Serial number",
    timeText: "Trading hours",
  },
  //推荐作品
  recommend: {
    recommendWork: "commended",
    moneySymbol: "$",
    rise: "since",
    saled: "A sale个出售",
    noMsg: "No recommended works at present"
  },
  //confirm弹窗
  confirm: {
    tips: "prompt"
  },
  //底部
  footer: {
    weixinCare: "WeChat attention",
    serviceNumber: "Mints service number",
    aboutUs: "About us",
    problems: "Q&A",
    concel: "Privacy policy",
    agreement: "Use agreement",
    Copyright: "2021015762 (ICP) Copyright © 2021 Beijing Mints Inc.",
    Copyright1: "京网信备11010521639830920018号"
  },
  //开盲盒
  // getBox: {
  //   boxDrop: "Blind box drops",
  //   workNum: "A work",
  //   later: "Open later",
  //   open: "Open the blind box",
  //   saved: "The blind box has been saved to the personal homepage",
  //   returnMyCenter: "Return to personal Center",
  //   goBack: "Return to previous page"
  // },
  getBox: {
    //打开盲盒页面
    Dropnum1: 'Blind box drops',
    Dropnum2: 'A work',
    laterOpen: 'Open later',
    openBoxBtnAll: 'Batch open',
    openBoxBtn: 'Open the blind box',
    laterToastMessage: 'The blind box has been saved to the personal homepage'
  },
  //头部
  header: {
    login: "Login",
    signOut: "exit",
    logOut: "Log out",
    newBox: "Blind Box",
    getMore: "Learn more",
    downApp: "Download APP",
    wallet: "The wallet balance",
    myCenter: "Personal home page",
    industry: 'industry information',
    language: 'language',
  },
  //kyc认证弹窗
  kycModal: {
    timesexhausted: "Today the number of authentication has been exhausted!",
    tomorrow: "Come again tomorrow",
  },
  //分享share
  share: {
    shareTo: "Share to",
    downFile: "The download file",
    poster: "Generate a poster",
    copyLink: "Copy the link",
    confirm: "cancel",
    savePicture: "Save the picture",
    longSave: "Long press to save the picture",
    copySuccess: "Copy it successfully, paste it to your friends!",
    clickTopRight: "Click on the upper right corner to select Friends to share",
    clickTopRight1: "Click on the upper right corner to choose Moments to share",
    copySuccess: "Copy success!",
    dontSuppot: "Wechat does not support download, please click on the upper right corner to use another browser to open!",
    weiChat: "WeChat",
    WechatMoments: "Circle of friends",
    sina: "Sina weibo",
  },
  //抽签码规则
  detailedRules: {
    text1: "Lottery code rules",
    text2: "1、 Participants",
    text3: "Registered user of thin box platform",
    text4: "2、 Activity rules",
    text5: " 1. Users can enter the lottery activity page during the activity period and complete the registration within the specified activity time to obtain a lottery code; Share the activity page with other users and get their help within the specified time of the activity, and you can get more lottery codes.",
    text6: "2. After the lottery is issued, the platform will randomly select a certain number of winning users from all the successful lottery codes and publicize them on the activity page. Users who receive the winning codes can successfully obtain free blind box prizes.",
    text7: "3. The same user can have up to 4 lottery codes to win the lottery. If multiple lottery codes belong to the same user, multiple blind boxes can be received when receiving the blind box.",
    text8: "4. In order to ensure fair activities, different user IDs exist under the following circumstances: those who can be judged as the same person, such as the same equipment number, the same identity authentication information and the same payment information, are regarded as the same user. Under the same user, they can get up to 4 prizes.",
    text9: "5. After the prize list is publicized, the collection time of the blind box is 3 hours. After exceeding the collection time limit, the blind box prize will not be collected. It is deemed that the user voluntarily gives up the qualification of winning the prize, and the thin box platform does not provide any form of compensation.",
    text10: "3、 Special note",
    text11: "1. During the event, in order to ensure the fairness of the event, if users are found to have violations (including but not limited to cheating, Bill swiping / quantity, false transaction, network attack, or acts that damage the legitimate rights and interests of other users, thin box platform and any third party, etc.), thin box platform will have the right to revoke the user's activity qualification, cancel all lottery codes and blind box qualification Tentative and limited services of the thin box platform (including but not limited to other forms of marketing activities on the thin box platform, etc.). If you have received the activity prize, the platform has the right to take back the blind box you have obtained. The user shall be responsible for the losses caused by trusting the third party.",
    text12: "2. Due to objective factors such as Internet technology, there may be some lag or errors in the information displayed on the thin box platform, which users know and understand. Therefore, when the activity is displayed with incorrect or obviously unreasonable information due to typographical error or information error, the thin box platform has the right to cancel the incorrect or obviously unreasonable blind box order.",
    text13: "3. In case of force majeure or change of circumstances (including but not limited to major disaster events, events that need to be stopped or adjusted by the instructions of government authorities, events that suffer serious network attacks or need to be held temporarily due to system failures), the user agrees that the thin box platform will not bear any responsibility for the change of event content (such as change of event rules, suspension or cancellation of activities, etc.).",
    text14: "4. Thin box platform has the right to change the description of these rules at any time. The changes will take effect once they are publicized. If you have any questions about these rules, please log in to thin box platform to find online customer service consultation."
  },
  // 消息中心
  myMessage: {
    message: 'message',
    allRead: 'AllRead',
    view: 'view',
    sysMsg: 'System message',
    sysAnnouncement: 'System of announcement',
    noMore: 'There is no more news',
    noMsg: 'No message',
    isAllRead: 'Do you mark all read?'
  },
  // 操作密码
  operatePass: {
    text1: 'Enter the current operation password',
    text2_1: 'Forgot your password? use',
    text2_2: 'SMS verification',
    text3: 'Get verification code',
    text3_1: 'Enter the verification code',
    text4: 'The verification code has been sent to your phone:',
    text5: 'Verification code',
    text6: 'Can be retrieved later',
    text7: 'Next step',
    text8: 'Set successfully',
    text9: 'Success',
    text10: 'The operation password is used for operations such as collection gifts',
    text11: 'Enter a new operation password',
    text12: 'Operation password',
    text13: 'The operation password has not been set yet',
    text14: 'Set operation password',
    text15: 'Verification code sent successfully! ',
    text16: 'Modify operation password',
    text17: 'Modify the new operation password',
    text18: 'Enter the new operation password again',
    text19: 'The 2 password entries are inconsistent! ',
    text20: 'Password set successfully! ',
    text21: 'Password changed successfully! ',
  },
  // 我的客服
  kfCode: {
    title: 'My customer service',
    text1: '(long press to save the QR code)',
    text2: 'VIP customer service QR code WeChat scan code to add exclusive customer service',
  },
  // 行业资讯
  industryInfo: {
    title: "Industry information"
  },
  // 首页banner
  newBanner: {
    status1: 'waiting room open',
    status2: 'event started',
    status3: 'event in progress',
    status4: 'event ended',
  },
  // 区块链查证信息
  cfxPage: {
    title: "Blockchain Verification Information",
    opusname: "collection name",
    creatorname: "Creator",
    confluxaddr: "Transaction Hash",
    ing: "On the chain...",
    blockhash: "Block Hash",
    paytime: "timestamp",
    sender: "Sender",
    receiver: "Receiver",
    contractaddr: "Contract address",
    status: "Status",
    sussess: "success",
    domain: "MNS name",
    name: "POAP name",
  },
  // 下载页面
  download: {
    text1: "Thin Box is committed to helping users build their own next-generation visual digital identity, confirming digital content based on blockchain technology, and providing trusted certificate storage technology and collection digital certificate technology services.",
    text2: "Developer: Beijing Box Technology Co., Ltd.",
    text3: "Version number:",
    text4: "Privacy Agreement",
    text5: "Thin Box User Agreement",
    text6: "Click the upper right corner to select the browser to open",
    text7: "If the browser fails to open, please move to the desktop to open the application directly",
  },
  //poapRule
  poapRule: {
    title: "What is POAP?",
    text1: "The POAP Digital Achievement Badge is a new way to credibly record life experiences, based on a proof-of-presence protocol on the blockchain and a protocol to record specific events by creating digital mementos.",
    text2: "Each POAP is a gift from the issuer to the collector to celebrate a special shared memory and testify to one's own experience with these 'historic' events.",
    text3: "By minting these memories into the blockchain, these memories are irreplaceable and immutable.",
    text4: "1. POAP is a unique digital collection.",
    text5: "2. The platform will create activities from time to time. You can get POAP by participating in related activities and events.",
    text6: "3. POAP is automatically triggered through smart contracts.",
    text7: "4. After you get POAP, transfer and sale are not supported.",
    text8: "5. You can display, view and share the POAPs you own in your personal center.",
  },
  // 首页收到礼物
  indexGiftShow: {
    text1: "Received from",
    text2: "Friend's Gift",
    btn1: "close",
    btn2: "Go check",
  },
  //盲盒赠送页面
  giftBox: {
    text1: "Gift Notes",
    text2: "Please read carefully and fully understand the following content",
    text3: "Digital collections/certificates do not have transaction value, they are only tools for right confirmation, please do not hype them.",
    text4: "Based on the anti-counterfeiting and traceability of commodities through digital certificates to protect the genuine value.",
    text5: "If you want to gift a friend's food collection offline, please also present the matching digital certificate to the recipient.",
    text6: "This digital collection shall not be used for speculation, over-the-counter transactions and any commercial purposes. If we find abnormal behaviors such as speculation, suspected violations of laws or regulations, or behavior prohibited by the agreement, we have the right to take necessary restrictive measures; including but not limited to freezing account, etc.",
    text7: "Please stay away from irrational speculation about digital collections and prevent fraud risks.",
    text8: "Reject",
    text9: "Agree",
    text10: "You have not set a password, please go to settings",
    text11: "Go to settings",
  },
  actKeys: {
    ruleModel: {
      title: "Activity Rules",
      text1: "Event time: 2022-09-01 to 2022-09-30. During the event, users who have not participated in the event will be invited to participate, register, authenticate, purchase blind boxes, etc. to obtain energy values ​​through sharing activities (limited blind box activities) sharing is invalid).",
      text2: "Energy Reward",
      text3: "1. Share invite friends to register +1 energy/person",
      text4: "2. Share and invite friends to complete real-name authentication, +2 energy/person",
      text5: "3. Share invites users to buy hardcover blind boxes, +5 energy/blind boxes.",
      text6: "4. The user buys a hardcover blind box, +10 energy/blind box",
      text7: "5. Invite 6 new users to pay for the purchase and get a hardcover blind box with no upper limit. The number of blind boxes is not within the 30 limit.",
      text8: "6. Share the special event, invite 1 user to participate in this event, and you can get the exclusive action of the digital character Jay Chou 'Brother thinks it can'.",
      text9: "The daily energy value is counted separately, and the energy value ranks first reward:",
      text10: "1. Get a legendary key.",
      text11: "2. Get a signed photo of Jay Chou.",
      text12: "3. Get a hardcover physical album of [The Greatest Work].",
      text13: "4. Get a limited poster.",
      text14: "The system determines that the highest score is reached first on the day. The above rewards are mainly based on the official distribution arrangement.",
      text16: "4. The daily limit of inviting friends + friend authentication is 800 energy. If you reach 800 energy, you will no longer get extra energy by inviting friends to complete registration or authentication."
    },
    page: {
      creatorName: "Jerwell",
      actName: "DEMO Music Space",
      goMscHome: "Enter Music Space",
      tickets: "Digital key to unlock Jay Chou Music Metaverse tickets",
      actTime: {
        title: "Activity period:",
        stime: "Event start time: August 29",
        etime: "Event end time: September 10",
      },
      rankInfo: {
        text1: "30 legendary keys and 30 signed photos of Jay Chou",
        text2: "[The greatest work] hardcover physical album + 30 limited posters",
      },
      btmShare: "Invite friends and get more surprises",
      news: {
        text1: "Congratulations user",
        text2: "Get",
        text3: "put",
      },
      moreAward: {
        text1: "Buy blind box to get",
      },
      textInfo1: "The 'digital key' is the only certificate for entering the 'Jay Chou Limited Collection DEMO Space'. The 'digital key' is divided into three levels: classic, rare, and legendary. This time, there are two types of blind boxes, hardcover blind boxes and limited blind boxes. ",
      navName1: "Event Details",
      navName2: "Leaderboard",
      rankTabName1: "Today's rank",
      rankTabName2: "Today's energy value",
      rankTabName3: "Cumulative energy value",
      rankTabName4: "Total number of people invited to buy",
      rankTableTh1: "Ranking",
      rankTableTh2: "Users",
      rankTableTh3: "Get energy value today",
      actTitle1: "Space admission voucher",
      actTitle2: "Blind Box Activity",
      actTitle3: "Leaderboard",
      rewardInfoTitle1: "Reward",
      rewardInfoTitle2: "Activity Conditions",
      sTit1: "Palace-level music art combined with front-end digital music audio-visual collection technology opens the first stop of Zhou's Yuan Universe",
      // sTit2: "Palace-level music art combined with front-end digital music audio-visual collection technology to open the first stop of Zhou's Yuan Universe",
      storyText: "Jewell Music and Thin Box Mints have joined forces across the border to create a Chinese music metaverse 'Jay Chou Limited Collection of DEMO Space'. The music DEMO space consists of 5 selected DEMO songs, each of which is personally selected by Jay Chou , including 4 songs that are highly popular and representative in the Chinese world, such as 'Blue and White Porcelain', 'Love in BC', 'Sunny Day', 'Stranded', and 1 song that has never been published and is extremely complete. Gao Ruxin's hidden DEMO track 'New York Subway'. 'Jay Chou Limited Collection DEMO Space' is not only the ultimate audio-visual feast for digital music collections in the Chinese music scene, but the two parties are also committed to combining the avant-garde style and design concept of Metaverse visual images, and integrating the original music Demo and blockchain technology expand new ideas for the future digital music collection world, and create a Jay-style music metaverse with a sense of future technology. Jay Chou, who always likes to challenge and try new things, will now bring his full load and previous experience with him. Unseen music energy launched the exclusive metaverse for the first time in the thin box, and every note, melody, arrangement, BEAT, lyrics, and picture created by Jay Chou's music will be advanced on the blockchain and become a classic collection that will never die. .",
      btn1: "￥20",
      btn2: "￥499",
      btn11: "Hardcover Blind Box",
      btn22: "Limited Blind Box",
      ruleName: "Activity Rule",
      noTableData: "No data currently",

      redT: {
        title: "JAY Red Hoodie",
        info1: "Buy a classic blind box or a rare blind box, you can automatically get a set of red hoodie 3D clothing (wearable digital collection), each person is limited to 1 set.",
        info2: "Unlimited time limit, can only be obtained during the event period.",
      },
      mns: {
        title: "MNS",
        info1: "Metaverse digital identity, buy a classic blind box or a rare blind box, you can get a MNS name 0 yuan quota, valid until the end of the event.",
        info2: "",
      },
      poap: {
        title: "POAP",
        info1: "After obtaining any key, you can get a POAP badge when you fully explore the Jay Chou Music Demo space, and when you reach a certain position in the space.",
        info2: "The total number of badges on the line is 100,000, and the donation is limited to 10,000.",
      },
    },
    rankPage: {
      index: "Number",
      user: "User",
      operation: "User Operation",
      value: "Energy value",
      dayValue: "Today's energy value",
      countValue: "Cumulative energy value",
      time: "Order time",
      boxReward: "Blind Box Reward",
      buyCount: "Total number of people invited to buy",
    }
  },
}



// WEBPACK FOOTER //
// ./src/i18n/config/en-us.js